import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../axiosBaseQuery";


const meaBoreholeApi = createApi({
    reducerPath: "core/measurement/borehole",
    baseQuery: axiosBaseQuery,
    tagTypes: ["measurementBoreholeList"],
    endpoints: (builder) =>({
        measurementBoreholeFindAll: builder.query<{ data: any[]; pagination: any }, string | void>({
            providesTags: ['measurementBoreholeList'],
            query: (query = '') => ({
                url: "core/measurement/borehole" + query,
                method: "GET",
            }),
            transformResponse: (response: any) => {
                return {
                    data: response.data,
                    pagination: response?.pagination,
                };
            },
        }),
        measurementBoreholeCreate: builder.mutation({
            invalidatesTags: ['measurementBoreholeList'],
            query: (data)=>({url: "core/measurement/borehole", method: "POST", data})
        }),
        measurementBoreholeUpdate: builder.mutation({
            invalidatesTags: ['measurementBoreholeList'],
            query: (data)=>({url: "/core/measurement/borehole/"+data.id, method: "PUT", data})
        }),
        measurementBoreholeDelete: builder.mutation({
            invalidatesTags: ['measurementBoreholeList'],
            query: (id)=>({url: "/core/measurement/borehole/"+id, method: "DELETE"})
        }),
    })
})

export const { useMeasurementBoreholeFindAllQuery, useMeasurementBoreholeCreateMutation, useMeasurementBoreholeUpdateMutation, useMeasurementBoreholeDeleteMutation } = meaBoreholeApi;
export {meaBoreholeApi};
